<template>
  <div>
    <detail-info-lot-paiement
      v-if="isDetail"
      :lot-paiement="lotPaiement">
    </detail-info-lot-paiement>
    <edit-info-lot-paiement
      v-else
      :lot-paiement="lotPaiement">
    </edit-info-lot-paiement>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow" v-if="!this.isDetail">
            <selecteur-actions
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="isLigneLotPaiementSelected"
            ></selecteur-actions>
          </div>
          <div class="column is-narrow">
            <form @submit.prevent="filter = filterInput">
              <b-input :placeholder="$t('general.button.search')"
                       type="search" icon="magnify"
                       v-model="filterInput">
              </b-input>
            </form>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="constantes.LOT_PAIEMENT.exporter"
            :query="exportExcelQuery"/>
        </div>
      </div>
    </div>
    <v-client-table :data="detailLotPaiementFilter" :columns="columns" :options="options"
                    class="tableWithChildRow" ref="lotPaiementliste">
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <qd-checkbox :value="props.row.selected"
                    @input="selectionLigneLotPaiement(props.row)">
        </qd-checkbox>
      </div>
      <div slot="nomCommercial" slot-scope="props" class="is-pulled-left">
        <router-link-blank
          :to="{ name: getRouteName, params: {id: props.row.tiers.id}}"
          :message="props.row.tiers.nomCommercial"
        />
      </div>
      <div slot="ligneRemiseBancairePseudoEntity.referenceReglement"
           slot-scope="props">
       <b-input :value="props.row.ligneRemiseBancairePseudoEntity.referenceReglement"
       @input="setReferenceReglement(props.row, $event)" v-if="!isDetail">
       </b-input>
        <div v-else>{{ props.row.ligneRemiseBancairePseudoEntity.referenceReglement }}</div>
      </div>
      <div slot="dateEffet" slot-scope="props" class="is-pulled-left">
        <b-datepicker :value="getDate(props.row.ligneRemiseBancairePseudoEntity.dateEffet)" editable
                      @input="setDateEffet(props.row, $event)" v-if="!isDetail">
        </b-datepicker>
        <div v-else>{{ props.row.ligneRemiseBancairePseudoEntity.dateEffet !== null ?
          props.row.ligneRemiseBancairePseudoEntity.dateEffet : null | formatDate }}</div>
      </div>
      <div slot="dateMouvement" slot-scope="props" class="is-pulled-left">
        <b-datepicker :value="getDate(props.row.dateMouvement)" editable
                 @input="setDateMouvement(props.row, $event)" v-if="!isDetail">
        </b-datepicker>
        <div v-else>{{ props.row.dateMouvement | formatDate }}</div>
      </div>
      <div slot="montant" slot-scope="props" class="is-pulled-right">
        {{ props.row.debit - props.row.credit | formatDevise}}
      </div>
      <div slot="delete" slot-scope="props" class="has-text-centered">
        <delete-list-button
          :query="(check) => deletePaiement([props.row.id], check)"
          :validation="validationSuppression"
          :permissions="constantes.LOT_PAIEMENT.supprimer"
          :title="$t('detailLotPaiement.suppression.title')"
          :labelCheckbox="$t('detailLotPaiement.suppression.checkbox')"
          :successMessage="$t('detailLotPaiement.messages.success.suppression')"
          @done="$router.go(0)"
          :tooltipLabel="$t('supprimerReglement.tooltip')"
          tooltipPosition="is-left"/>
      </div>
      <template slot='appendBody'>
        <table-footer-totaux
          ref="tableTotaux"
          :columns="columns"
          :target="targetTotal"
          :items="detailLotPaiementFilter">
        </table-footer-totaux>
      </template>
    </v-client-table>
    <b-modal v-model="popUpEditionReferenceReglement"
             has-modal-card
             class="modal">
    <pop-up-edition-reference-paiement
    @referencePaiement="editSelectedLigneWithReferencePaiement"></pop-up-edition-reference-paiement>
    </b-modal>
    <b-modal
        v-model="popUpSuppression.open"
        has-modal-card
        class="modal"
        @close="popUpSuppression.open = false">
      <popUpPrevention
          :messHeader="$t('detailLotPaiement.suppression.title')"
          :labelCheckbox="$t('detailLotPaiement.suppression.checkbox')"
          :cancel="this.$t('general.non')"
          :validate="this.$t('general.oui')"
          :messagesPopup="popUpSuppression.messages"
          :isErrorPopup.sync="popUpSuppression.isError"
          @yes="deletePaiementPopUp"
          @no="popUpSuppression.open = false" >
      </popUpPrevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import inProgress from '@/services/general/inProgress';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import {
  deleteLotPaiementEnCours,
} from '@/api/remiseBancaire';
import childRowDetailReglement from '@/components/remiseBancaire/c_childRowDetailReglement';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import selecteurActions from '@/components/general/selecteurAction';
import { LOT_PAIEMENT } from '@/configuration/baux/permissionsBauxConf';
import editInfoLotPaiement from '@/components/baux/lotPaiement/edit/m_infoLotPaiement';
import detailInfoLotPaiement from '@/components/baux/lotPaiement/detail/c_infoLotPaiement';
import messageErreur from '@/services/general/messageErreur';
import { LOT_PAIEMENT_EXPORT, ACTION_EDIT_REFERENCE_REGLEMENT, ACTION_DELETE_PAIEMENT } from '@/configuration/lotPaiement/lotPaiementConf';
import popUpEditionReferencePaiement from '@/components/lotPaiement/popUpEditionReferencePaiement';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import messageSucces from '@/services/general/messageSucces';
import popUpPrevention from '@/components/general/popUpPrevention';
import validationSuppression from '@/services/baux/lotPaiement/validationSuppression';
import deleteListButton from '@/components/general/button/deleteListButton';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { MODULE_TLPE } from '@/configuration/devisConf';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    detailLotPaiement: {
      type: Array,
      required: true,
    },
    lotPaiement: {
      type: Object,
      required: true,
    },
    isDetail: {
      type: Boolean,
      required: true,
    },
    moduleDcf: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      filter: '',
      filterInput: '',
      actions: [
        { action: ACTION_EDIT_REFERENCE_REGLEMENT, translation: 'detailLotPaiement.actions.editionReferencePaiement' },
        { action: ACTION_DELETE_PAIEMENT, translation: 'detailLotPaiement.actions.suppressionPaiement' },
      ],
      constantes: {
        LOT_PAIEMENT,
      },
      popUpEditionReferenceReglement: false,
      popUpSuppression: {
        open: false,
        messages: [],
        isError: false,
        target: [],
      },
      validationSuppression,
    };
  },
  components: {
    routerLinkBlank,
    selecteurActions,
    editInfoLotPaiement,
    detailInfoLotPaiement,
    popUpEditionReferencePaiement,
    tableFooterTotaux,
    popUpPrevention,
    deleteListButton,
    exportExcelButton,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    isLigneLotPaiementSelected() {
      return this.detailLotPaiement.some(item => item.selected);
    },
    allLigneLotPaiementSelected() {
      return this.detailLotPaiementFilter.length > 0
        && !this.detailLotPaiementFilter.some(item => !item.selected);
    },
    detailLotPaiementFilter() {
      return this.detailLotPaiement.filter(item => {
        const fields = [
          item.tiers.nomCommercial,
          item.ligneRemiseBancairePseudoEntity.emetteur,
        ];
        return fields.some(field => field
        && field.toLowerCase().includes(this.filter.toLowerCase()));
      });
    },
    targetTotal() {
      return ['montant'];
    },
    iconSelectTotal() {
      if (this.allLigneLotPaiementSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          'ligneRemiseBancairePseudoEntity.referenceReglement': this.$t('detailLotPaiement.tab.referencePaiement'),
          'ligneRemiseBancairePseudoEntity.emetteur': this.$t('detailLotPaiement.tab.nomTire'),
          dateMouvement: this.$t('detailLotPaiement.tab.datePaiement'),
          dateEffet: this.$t('detailLotPaiement.tab.dateEffet'),
          montant: this.$t('detailLotPaiement.tab.montant'),
          nomCommercial: this.$t('detailLotPaiement.tab.fournisseur'),
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    const allSelected = this.allLigneLotPaiementSelected;
                    this.detailLotPaiement.forEach(item => {
                      item.selected = !allSelected;
                    });
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        childRow: childRowDetailReglement,
        columnsClasses: {
          selected: 'colonneSelected',
        },
        sortable: this.isDetail ? ['ligneRemiseBancairePseudoEntity.referenceReglement', 'nomCommercial', 'ligneRemiseBancairePseudoEntity.emetteur', 'dateMouvement', 'dateEffet', 'montant'] : [],
      };
    },
    columns() {
      const columns = ['ligneRemiseBancairePseudoEntity.emetteur', 'ligneRemiseBancairePseudoEntity.referenceReglement', 'nomCommercial', 'dateMouvement', 'dateEffet', 'montant'];
      if (!this.isDetail) columns.unshift('selected');
      if (!this.isDetail) {
        columns.push('delete');
      }
      return columns;
    },
    exportExcelQuery() {
      return {
        typeDonnee: LOT_PAIEMENT_EXPORT,
        typeExport: '',
        filtres: {
          query: {
            lotPaiementId: this.$route.params.id,
            societeId: this.societeActiveId,
          },
        },
      };
    },
    getRouteName() {
      return this.moduleDcf === MODULE_TLPE ? 'c.gabed.collectivite' : 'c.baux.bailleur';
    },
  },
  methods: {
    getDate(date) {
      if (!date) return null;
      return new Date(date);
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    setReferenceReglement(value, reference) {
      const ligne = this.detailLotPaiement.find((item) => {
        return item.id === value.id;
      });
      ligne.ligneRemiseBancairePseudoEntity.referenceReglement = reference;
    },
    setDateMouvement(value, reference) {
      const ligne = this.detailLotPaiement.find((item) => {
        return item.id === value.id;
      });
      ligne.dateMouvement = reference;
    },
    setDateEffet(value, reference) {
      const ligne = this.detailLotPaiement.find((item) => {
        return item.id === value.id;
      });
      ligne.ligneRemiseBancairePseudoEntity.dateEffet = reference;
    },
    editSelectedLigneWithReferencePaiement(newReferenceReglement) {
      this.popUpEditionReferenceReglement = false;
      let referenceReglementCloned = cloneDeep(Number(newReferenceReglement));
      this.$refs.lotPaiementliste.filteredData.forEach((paiementFiltered) => {
        if (paiementFiltered.selected) {
          this.setReferenceReglement(paiementFiltered, referenceReglementCloned);
          referenceReglementCloned += 1;
        }
      });
    },
    async deletePaiementPopUp(checkbox) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.deletePaiement(this.popUpSuppression.target, checkbox);
        messageSucces(this.$t('detailLotPaiement.messages.success.suppression'));
        this.popUpSuppression.open = false;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response) {
          this.popUpSuppression.isError = true;
          validationSuppression(e.response, this.popUpSuppression.messages);
        } else {
          messageErreur(this.$i18n);
        }
        throw e;
      }
      this.$router.go(0);
    },
    async deletePaiement(ids, checkbox) {
      if (ids.length === 0) {
        messageErreur(this.$i18n, 'general.messages.error.emptySelection');
        return;
      }
      await deleteLotPaiementEnCours(this.lotPaiement.id, checkbox, ids);
    },
    handleAction(action) {
      const selected = this.$refs.lotPaiementliste.filteredData
        .filter(p => p.selected)
        .map(p => p.id);
      switch (action) {
        case ACTION_EDIT_REFERENCE_REGLEMENT:
          this.popUpEditionReferenceReglement = true;
          break;
        case ACTION_DELETE_PAIEMENT:
          this.popUpSuppression.open = true;
          this.popUpSuppression.target = selected;
          break;
        default:
          break;
      }
    },
    selectionLigneLotPaiement(value) {
      const ligne = this.detailLotPaiement.find((item) => {
        return item.id === value.id;
      });
      ligne.selected = !value.selected;
    },
  },
  mounted() {
    if (this.isDetail) {
      this.actions = [];
    }
  },
};
</script>
